var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"darker":true,"hideHeader":true,"hideButtonsContainer":true},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('Loader',{attrs:{"withMessage":_vm.withMessage,"message":_vm.message}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }